// import { useI18n } from 'vue-i18n'
export default function () {
  return window.$i18n.global.locale == 'en' ? 2 : 1
}
